module.exports = __webpack_public_path__ + "static/CookiesChef_part1-93eacf268f4e7dc57d19fb8b67bde046.mp3";